import React from "react";
import { useAuth } from "../context/AuthContext";

// Only session status is displayed. Credentials and personal data are not logged.
const TestAuth = () => {
  const { isAuthenticated } = useAuth();
  return <p>Sessão: {isAuthenticated ? "autenticada" : "não autenticada"}</p>;
};
export default TestAuth;
